"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ic_dehaze = exports.ic_dehaze = { "viewBox": "0 0 24 24", "children": [{ "name": "path", "attribs": { "d": "M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z" } }] };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/md/ic_dehaze.js
// module id = 661
// module chunks = 0